import { GraphQLExecutor } from '@app/model/_common/service/GraphQLExecutor';
import Return from '@app/model/_common/Return';
import {
	FIND_COMPANY_DEPARTMENTS_QUERY, FIND_COMPANY_SETTINGS_QUERY,
	FINISH_COMPANY_HOTELS_INFO_MUTATION,
	FINISH_COMPANY_HOTELS_RANKING_MUTATION, REMOVE_COMPANY_DEPARTMENT_MUTATION,
	RUN_COMPANY_HOTEL_RANKING_MUTATION,
	RUN_COMPANY_HOTELS_INFO_MUTATION, SAVE_COMPANY_DEPARTMENT_MUTATION,
} from '@app/model/company/service/CompanyGraphQLQueries';
import CompanyDepartment from '@app/model/company/CompanyDepartment';
import CompanyDepartmentInput from '@app/model/company/input/CompanyDepartmentInput';
import CompanySettings from '@app/model/company/CompanySettings';


class CompanyService {
	public static runCompanyHotelsInfo(companyHotelId: number) {
		return GraphQLExecutor.execute<Return>(RUN_COMPANY_HOTELS_INFO_MUTATION, { companyHotelId });
	}

	public static finishCompanyHotelsInfo() {
		return GraphQLExecutor.execute<Return>(FINISH_COMPANY_HOTELS_INFO_MUTATION, {});
	}

	public static runCompanyHotelsRanking(companyHotelId: number) {
		return GraphQLExecutor.execute<Return>(RUN_COMPANY_HOTEL_RANKING_MUTATION, { companyHotelId });
	}

	public static finishCompanyHotelsRanking() {
		return GraphQLExecutor.execute<Return>(FINISH_COMPANY_HOTELS_RANKING_MUTATION, {});
	}

	public static findCompanySettings() {
		return GraphQLExecutor.execute<CompanySettings>(FIND_COMPANY_SETTINGS_QUERY, {});
	}

	public static async findCompanyDepartments() {
		const response = await GraphQLExecutor.execute<CompanyDepartment[]>(
			FIND_COMPANY_DEPARTMENTS_QUERY,
		);
		return response || [];
	}

	public static saveCompanyDepartment(input: CompanyDepartmentInput) {
		return GraphQLExecutor.execute<CompanyDepartment>(SAVE_COMPANY_DEPARTMENT_MUTATION, { input });
	}

	public static removeCompanyDepartment(departmentId: number) {
		return GraphQLExecutor.execute<CompanyDepartment>(REMOVE_COMPANY_DEPARTMENT_MUTATION, { departmentId });
	}
}

export default CompanyService;